import {Component, Host, Input, Optional} from '@angular/core';
import {ButtonGroupComponent} from '../button-group/button-group.component'

@Component({
  selector: 'app-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
})
export class ButtonComponent {

  inGroup = false

  constructor(@Optional() @Host() parent: ButtonGroupComponent) {
    this.inGroup = parent !== null
  }

  @Input()
  id: number | undefined

  @Input()
  label: string | undefined

  @Input()
  name: string | undefined

  @Input()
  description: string | undefined

  @Input()
  eventName: string | undefined

  @Input()
  imageSource: string | undefined

  @Input()
  disabled = false

  @Input()
  selected = false

}
